exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.refund-value[data-v-aa6f720c] {\n  font-size: 20px;\n  font-weight: 500;\n}\n.refund-covered-title[data-v-aa6f720c] {\n  font-size: 12px;\n  font-weight: 400;\n  color: #bec0ca;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa6f720c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/Refunds.vue
// module id = jfcM
// module chunks = 0